import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
const lucy = require("../../../helpers/lucy_service");

const ConversationsTab = ({ sub }) => {
  const [rows, setRows] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [next, setNext] = useState(null);
  const [stack, setStack] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(
    async (c) => {
      setLoading(true);
      try {
        const res = await lucy.getUserConversations(sub, { cursor: c, pageSize: 25 });
        setRows(res.data.response.items || []);
        setNext(res.data.response.nextCursor || null);
      } finally {
        setLoading(false);
      }
    },
    [sub]
  );

  useEffect(() => {
    load(null);
  }, [load]);

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Metadata de las conversaciones del usuario (no se muestra el contenido).
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Título</TableCell>
                <TableCell>Creada</TableCell>
                <TableCell>Actualizada</TableCell>
                <TableCell align="right">Mensajes</TableCell>
                <TableCell align="right">Tokens</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Etiquetas</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.conversationId} hover>
                  <TableCell>{r.title}</TableCell>
                  <TableCell>{new Date(r.createdAt).toLocaleDateString("es-GT")}</TableCell>
                  <TableCell>{new Date(r.updatedAt).toLocaleString("es-GT")}</TableCell>
                  <TableCell align="right">{r.messageCount || 0}</TableCell>
                  <TableCell align="right">
                    {((r.tokensIn || 0) + (r.tokensOut || 0)).toLocaleString("es-GT")}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={r.status}
                      color={r.status === "active" ? "success" : "default"}
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {(r.tags || []).map((t) => (
                        <Chip key={t} size="small" variant="outlined" label={t} />
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
              {!rows.length && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Sin conversaciones
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      )}
      <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
        <Button
          size="small"
          disabled={!stack.length}
          onClick={() => {
            const prev = [...stack];
            const to = prev.pop();
            setStack(prev);
            setCursor(to || null);
            load(to || null);
          }}
        >
          Anterior
        </Button>
        <Button
          size="small"
          disabled={!next}
          onClick={() => {
            setStack([...stack, cursor]);
            setCursor(next);
            load(next);
          }}
        >
          Siguiente
        </Button>
      </Box>
    </Box>
  );
};

export default ConversationsTab;
